import { GenericErrorWidget } from 'components/errorpages/GenericErrorWidget';

export function GenericErrorPage() {
  return (
    // inline style added to stay true to the design
    <div style={{ maxWidth: 885 }} className="flex h-screen items-center mx-auto">
      <GenericErrorWidget />
    </div>
  );
}
